

<template >
  <div class="container">
    <h3 class="font-weight-bold mb-4 centers" style="margin-top: 165px;">Nos Besoins</h3>
    <div
      v-for="(besoin, index) in besoins"
      :key="besoin.id"
      class="container"
    >
      <div class="row margetop" :id="besoin.titre.toLowerCase().replace(/\s+/g, '-')">
        
        <!-- Cas pair : image à gauche, texte à droite -->
        <template v-if="index % 2 === 0" >
          <div class="col-lg-5" :style="{ marginTop: '50px' }">
            <img
              class="test"
              :src="`https://admin.asso-refuge.fr/images/${besoin.img}`"
              :alt="besoin.titre"
            />
          </div>
              <div class="col-lg-1"></div>
          <div class="col-lg-5" :style="{ marginTop: '50px' }">
            <h3 class="font-weight-bold mb-4 justus">{{ besoin.titre }}</h3>
            <div v-html="besoin.content"></div>
          </div>
        </template>
        <!-- Cas impair : texte à gauche, image à droite -->
        <template v-else>


          <div class="col-lg-5" :style="{ marginTop: '50px' }">
            <h3 class="font-weight-bold mb-4 justus">{{ besoin.titre }}</h3>
            <div v-html="besoin.content"></div>
          </div>
          <div class="col-lg-1"></div>
          <div class="col-lg-5" :style="{ marginTop: '50px' }">
            <img
              class="test"
              :src="`https://admin.asso-refuge.fr/images/${besoin.img}`"
              :alt="besoin.titre"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<style src="../assets/css/besoin.css"></style>


<script>
export default {
  data() {
    return {
      besoins: [],
    };
  },
  methods: {
    decodeHtmlEntities(text) {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = text;
      return textarea.value;
    }
  },
mounted() {
  const idSite = this.$idSite;
  fetch(`https://admin.asso-refuge.fr/getBesoins/${idSite}`)
    .then(response => response.json())
    .then(data => {
      const formattedBesoins = data
        .map(besoin => {
          const content = this.decodeHtmlEntities(besoin.content)
            .replace(/onload="[^"]*"/gi, ''); // supprime tout attribut onload
          return {
            ...besoin,
            content
          };
        })
        .sort((a, b) => a.id - b.id); // 🔹 tri par ID croissant

      this.besoins = formattedBesoins;
    })
    .catch(error => {
      console.error('Il y a eu un problème avec votre requête :', error.message);
    });
}
};
</script>